let total = 0; // Initialize total amount
let lastSelectedPersonalizationRadio = null; // Track last selected radio for personalization
let lastSelectedDeliveryRadio = null; // Track last selected radio for delivery

// Function to show steps when dropdown is selected
function showSteps(select) {
  const steps = document.querySelectorAll('.step-content');
  steps.forEach(step => step.style.display = select.value ? 'block' : 'none');

  // Get the selected value
  var selectedValue = select.value;

  // Show/Hide based on selection
  document.querySelectorAll('.normal-options').forEach(el => el.style.display = selectedValue === 'normal' ? 'block' : 'none');
  document.querySelectorAll('.magnum-options').forEach(el => el.style.display = selectedValue === 'magnum' ? 'block' : 'none');

  // Reset the total and uncheck all checkboxes
  resetForm();
}

// Function to reset the form and total
function resetForm() {
  total = 0;

  // Uncheck all checkboxes
  const allCheckboxes = document.querySelectorAll('input[type="checkbox"]');
  allCheckboxes.forEach(checkbox => {
    checkbox.checked = false; // Uncheck the checkbox
    const parentElement = checkbox.closest('.checkbox-container');
    if (parentElement) {
      parentElement.classList.remove('selected'); // Remove selected class (green border)
    }
  });

  // Reset last selected radios
  lastSelectedPersonalizationRadio = null;
  lastSelectedDeliveryRadio = null;

  // Update total amount display
  updateTotal();
}

// Function to toggle selection of items and update total price for checkboxes
function toggleSelection(element, price, category) {
  const checkbox = element.querySelector('input[type="checkbox"]'); // Find the checkbox inside the card
  const checkboxesInCategory = document.querySelectorAll(`input[type="checkbox"][data-category="${category}"]`);

  if (checkbox.checked) {
    checkbox.checked = false; // Uncheck the checkbox
    total -= price; // Subtract the price from the total
    element.classList.remove('selected'); // Remove selected class for visual indication
  } else {
    checkboxesInCategory.forEach(cb => {
      const parentElement = cb.closest('.checkbox-container');
      if (cb.checked) {
        total -= parseFloat(cb.dataset.price); // Subtract the price of the previously selected checkbox
        cb.checked = false; // Uncheck the previous checkbox
        parentElement.classList.remove('selected'); // Remove selected class
      }
    });

    checkbox.checked = true; // Check the current checkbox
    total += price;
    element.classList.add('selected'); // Add selected class for visual indication
  }

  // Update total amount display
  updateTotal();
}

// Function to update the total price based on "personalization" radio buttons
function updatePersonalizationTotal(price, radioElement) {
  if (lastSelectedPersonalizationRadio && lastSelectedPersonalizationRadio !== radioElement) {
    const previousPrice = parseFloat(lastSelectedPersonalizationRadio.value) || 0;
    total -= previousPrice;
  }

  const selectedPrice = parseFloat(price) || 0;
  total += selectedPrice;

  updateTotal();
  lastSelectedPersonalizationRadio = radioElement;
}

// Function to update the total price based on "delivery preference" radio buttons
function updateDeliveryTotal(price, radioElement) {
  if (lastSelectedDeliveryRadio && lastSelectedDeliveryRadio !== radioElement) {
    const previousPrice = parseFloat(lastSelectedDeliveryRadio.value) || 0;
    total -= previousPrice;
  }

  const selectedPrice = parseFloat(price) || 0;
  total += selectedPrice;

  updateTotal();
  lastSelectedDeliveryRadio = radioElement;
}

// Function to update the total amount display
function updateTotal() {
  document.getElementById('totalAmount').innerText = total.toFixed(2);
  document.getElementById('totalprice').value = total.toFixed(2);
}

// Initialize the total amount display on page load
window.onload = updateTotal;
